import { FC, ReactElement, useState } from 'react'
import styled, { ThemeProvider, createGlobalStyle } from 'styled-components'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers"
import Body from '../Body'
// import Header from '../Header'
// import useFetch from 'react-fetch-hook'

// Story: https://master.dev.bilan.ch/story/lorem-ipsum-dolor-sit-amet-330498335711?preview_key=6500f289534e02e5216dadc96af33f03

const GlobalStyle = createGlobalStyle`
  :root {
    --font-title: 'Lora', serif;
  }
`

const defaultProperties: { [key: string]: string } = {
  module: 'list',
  title: 'Le panorama des pépites de l’économie romande',
  text: "Le magazine Bilan recense les fondatrices et fondateurs romands d'entreprise ayant atteint une certaine maturité. Cette opération annuelle met en lumière les accomplissements et projets de la nouvelle génération aux commandes de sociétés en pleine croissance.",
  sup: 'Entrepreneuriat −40 ans',
}

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties = defaultProperties,
}): ReactElement => {
  const [ref, setRef] = useState<HTMLDivElement | null>(null)

  // const { isLoading, data, error } = useFetch(
  //   'https://storage.googleapis.com/wch-interactive/bilan-jeunes-entrepreneurs/list-2025.json',
  //   {
  //     formatter: (response: Response) => response.json(),
  //   }
  // )

  // console.log(data, data)

  const modules: { [key: string]: ReactElement } = {
    // header: (
    //   <Header
    //     title={properties.title as string}
    //     sup={properties.sup as string}
    //     tenant={tenant}
    //     text={properties.text as string}
    //     date={isLoading ? new Date(31, 5, 2023) : new Date(data.updated) }
    //   />
    // ),
    list: <Body />,
  }

  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]

  const theme = {
    colorMode: colorMode,
    mainColor: colorMode === 'dark' ? '#d1383b' : '#aa0a0c',
    textColor: colorMode === 'dark' ? '#ffffff' : '#121212',
    lightGrey: colorMode === 'dark' ? '#121212' : '#f5f6f7',
    darkGrey: colorMode === 'dark' ? '#111111' : '#e9e9e9',
    buttonColor: colorMode === 'dark' ? '#ebebeb' : '#ebebeb',
    buttonTextColor: colorMode === 'dark' ? '#121212' : '#121212',
    lineColor: colorMode === 'dark' ? '#333333' : '#eaebed',
    lineColorDark: colorMode === 'dark' ? '#444444' : '#d5d7d7',
    secondaryButtonBackground:
      colorMode === 'dark'
        ? 'var(--brandblue-bright-2)'
        : 'var(--beige-bright-2)',
    secondaryButtonText: colorMode === 'dark' ? '#ffffff' : '#121212',
    primaryButtonBackground: '#121212',
    primaryButtonText:
      colorMode === 'dark' ? 'var(--brandblue-main)' : '#ffffff',
    coloredBackground:
      colorMode === 'dark' ? '#121212' : '#f4f4f4',
    textSizeSmall: '1.4rem',
    textSizeMedium: '1.6rem',
    texteSizeLarge: '2.4rem',
    textGrey: '#7d7d7d',
    siteBackground: colorMode === 'dark' ? '#121212' : '#ffffff',
    tenant: tenant as Tenant,
  }

  if (ref) {
    const rootNode = ref.getRootNode() as ShadowRoot
    const hostNode = rootNode.host as HTMLElement
    if (hostNode) {
      const parentNode = rootNode.host.parentNode as HTMLElement
      if (parentNode) parentNode.style.setProperty('margin', 'auto')
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <AppContainer className={globalClasses.join(' ')} ref={setRef}>
        <GlobalStyle />
        {properties?.module && modules[properties.module]}
      </AppContainer>
    </ThemeProvider>
  )
}

const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  margin-bottom: 60px;
  scroll-behavior: smooth;
`

export default MainComponent
